export default __webpack_public_path__ + "static/media/tech_specs_icon.f0d76ce6.svg";